import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.scss';
import Visualization from './components/Visualization/Visualization';
import Landing from './components/Landing/Landing';
import MainMenu from './components/MainMenu/MainMenu';
import Tests from './components/Tests/Tests';

const App = () => {
  return (
    <Router basename="/max-flow">
      <Routes>
        <Route path="/" element={<MainMenu />}>
          <Route path="/" element={<Landing />} />
          <Route
            path="/ford-fulkerson"
            element={<Visualization key="ford-fulkerson" algo="ford-fulkerson" />}
          />
          <Route
            path="/edmonds-karp"
            element={<Visualization key="edmonds-karp" algo="edmonds-karp" />}
          />
          <Route path="/dinic" element={<Visualization key="dinic" algo="dinic" />} />
          <Route
            path="/goldberg-tarjan"
            element={<Visualization key="goldberg-tarjan" algo="goldberg-tarjan" />}
          />
          <Route path="/tests" element={<Tests />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
